import { useMemo } from 'react';
import * as yup from 'yup';

export const usePlayerFormValidationSchema = () =>
    useMemo(
        () =>
            yup.object({
                firstName: yup.string().required('First Name is required'),
                lastName: yup.string().required('Last Name is required'),
                jerseyNumber: yup.number().integer(),
            }),
        [],
    );
